"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* istanbul ignore file */

function insertAfter(newNode, existingNode) {
  existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
}
function returnError(pastedText, ele, eleSubject, errorSubject, eleDescription, error) {
  if (ele === eleSubject) {
    insertAfter(errorSubject, eleSubject);
    if (pastedText.length >= 255) {
      errorSubject.textContent = '255 character limit';
    } else {
      errorSubject.textContent = '';
    }
  } else {
    insertAfter(error, eleDescription);
    if (pastedText.length >= 255) {
      error.textContent = '255 character limit';
    } else {
      error.textContent = '';
    }
  }
}
const SFchat = props => {
  const {
    domainName,
    siteUrl,
    deploymentId,
    orgID,
    buttonId,
    instanceID,
    eswLiveAgentDevName,
    email,
    displayHelpButton,
    language,
    featuresType,
    helpCentreLink
  } = props;
  const initESW = gslbBaseURL => {
    const embedded_svc = window.embedded_svc;
    embedded_svc.settings.displayHelpButton = displayHelpButton; //Or false
    embedded_svc.settings.language = language; //For example, enter 'en' or 'en-US'
    embedded_svc.settings.enabledFeatures = [featuresType];
    embedded_svc.settings.entryFeature = featuresType;
    embedded_svc.init("https://".concat(domainName, ".my.salesforce.com"), siteUrl, gslbBaseURL, orgID, eswLiveAgentDevName, {
      baseLiveAgentContentURL: "https://c.".concat(instanceID, ".salesforceliveagent.com/content"),
      deploymentId,
      buttonId,
      baseLiveAgentURL: "https://d.".concat(instanceID, ".salesforceliveagent.com/chat"),
      eswLiveAgentDevName,
      isOfflineSupportEnabled: true
    });
    embedded_svc.addEventHandler("onHelpButtonClick", function (data) {
      modifyForm();
    });
  };
  const modifyForm = () => {
    // there is no other way to pre-populate useremail field hence listening on DOMSubtreeModified
    document.querySelector('body').addEventListener('DOMSubtreeModified', function DOMSubtreeModified() {
      let eleEmail = document.getElementById('SuppliedEmail');
      let eleSubject = document.getElementById('Subject');
      let eleDescription = document.getElementById('Description_for_Chat__c');
      let embeddedServiceSidebarForm = document.querySelector('.embeddedServiceSidebarForm .fieldList');
      if (eleEmail) {
        document.querySelector('body').removeEventListener('DOMSubtreeModified', DOMSubtreeModified, false);

        // create a new error node
        let error = document.createElement('div');
        error.style.fontSize = 'var(--lwc-esFontSizeTextXSmall,0.75em)';
        error.style.color = 'var(--warning)';
        error.style.margin = ".5em .5em 0";
        let errorSubject = document.createElement('div');
        errorSubject.style.fontSize = 'var(--lwc-esFontSizeTextXSmall,0.75em)';
        errorSubject.style.color = 'var(--warning)';
        errorSubject.style.margin = ".5em .5em 0";
        let helpCenter = document.createElement('a');
        helpCenter.href = helpCentreLink;
        helpCenter.target = '_blank';
        helpCenter.textContent = 'Place Exchange Help Center';
        helpCenter.style.fontSize = 'var(--lwc-esFontSizeTextXSmall,0.75em)';
        insertAfter(helpCenter, embeddedServiceSidebarForm);
        [eleSubject, eleDescription].forEach(ele => {
          ele.addEventListener('keyup', e => {
            returnError(ele.value, ele, eleSubject, errorSubject, eleDescription, error);
          });
          ele.onpaste = e => {
            if (e.clipboardData && e.clipboardData.getData) {
              let pastedText = e.clipboardData.getData('text/plain');
              // insert a new node after the last list item
              returnError(pastedText, ele, eleSubject, errorSubject, eleDescription, error);
            }
          };
        });
        eleSubject.setAttribute('autocomplete', 'off');
        eleDescription.setAttribute('autocomplete', 'off');
        eleEmail.value = email;
        setTimeout(() => {
          eleEmail.dispatchEvent(new Event('change'));
        }, 1000);
        document.querySelector('.inputEmail.embeddedServiceSidebarFormField').style.display = 'none';
      }
    });
  };
  (0, _react.useEffect)(() => {
    if (!window.embedded_svc) {
      var s = document.createElement('script');
      s.setAttribute('src', "https://".concat(domainName, ".my.salesforce.com/embeddedservice/5.0/esw.min.js"));
      s.onload = function () {
        initESW(null);
      };
      document.body.appendChild(s);
    }
  }, [window.embedded_svc]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
var _default = exports.default = SFchat;